module.exports = __webpack_public_path__ + "static/img/lost-ethereal-lucre-games-pixel-art-banner.cd82284.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-lucre-games-pixel-art-banner.jpg
// module id = xIC3
// module chunks = 0